import React from "react";
import { getImageDimensions } from "@sanity/asset-utils";
import urlBuilder from "@sanity/image-url";
import sanity from "../../constants/sanity";

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  isInline: boolean;
  title: string;
}

const PostImage = ({ value, isInline, title }: Props) => {
  const { width, height } = getImageDimensions(value);

  return (
    <img
      src={urlBuilder()
        .image(value)
        .projectId(sanity.PROJECT_ID)
        .dataset("blogg")
        .image(value)
        .width(isInline ? 100 : 800)
        .fit("max")
        .format("webp")
        .auto("format")
        .quality(100)
        .url()}
      alt={title}
      loading="lazy"
      style={{
        // Display alongside text if image appears inside a block text span
        display: isInline ? "inline-block" : "block",
        width: "100%",
        maxWidth: "800px",
        margin: "auto",

        // Avoid jumping around with aspect-ratio CSS property
        aspectRatio: width / height,
      }}
    />
  );
};

export default PostImage;
